export default "__VITE_ASSET__BX2FQO_k__"